module.exports = __webpack_public_path__ + "img/objectshuffle.d8d85efa.png";